import { observer } from "mobx-react";
import { h } from "preact";
import { t, translate } from "restaumatic-client";
function EditBlock(props) {
    const { isDisabled = false, actionTrigger = "button", actionLabel = translate(t.actions.change), hasError = false, } = props;
    const prefixCentered = props.description === undefined;
    return (h(Container, { btnRef: props.actionBtnRef, actionTrigger: actionTrigger, actionLabel: actionLabel, ariaLabel: props.ariaLabel, ariaValue: props.title, hasError: hasError, isDisabled: isDisabled, onClick: props.onClick, dataFieldId: props.dataFieldId },
        props.prefixType === "icon" && (h(IconPrefix, { icon: props.prefixIcon, centered: prefixCentered })),
        props.prefixType === "image" && (h(ImagePrefix, { imageUrl: props.prefixImageUrl, centered: prefixCentered })),
        h(Content, { title: props.title, description: props.description, footer: props.footer }),
        !isDisabled && (h(Action, { btnRef: props.actionBtnRef, trigger: actionTrigger, label: actionLabel, onClick: props.onClick, dataFieldId: props.dataFieldId }))));
}
const IconPrefix = (props) => {
    return (h("div", { class: `m-edit-block__icon ${props.centered ? "m-edit-block__icon--centered" : ""}`, "aria-hidden": "true" },
        h("i", { class: `icon-${props.icon} icon-base icon-among-text` })));
};
const ImagePrefix = (props) => {
    return (h("div", { class: "m-edit-block__image", "aria-hidden": "true" },
        h("img", { src: props.imageUrl, alt: "" })));
};
const Content = (props) => {
    const { title, description, footer } = props;
    const hasDescription = props.description !== undefined;
    const hasFooter = props.footer !== undefined;
    const hasOnlyTitle = !hasDescription && !hasFooter;
    return (h("div", { class: "m-edit-block__content" },
        h("div", { class: `m-edit-block__title ${hasOnlyTitle ? "u-text-normal" : ""}` }, title),
        hasDescription && h("p", { class: "m-edit-block__description" }, description),
        hasFooter && (h("div", { class: "m-edit-block__footer" },
            h("span", null, footer)))));
};
const Action = observer((props) => {
    const { btnRef, trigger, label, dataFieldId, onClick } = props;
    return (h("div", { class: "m-edit-block__action" },
        trigger === "button" && (h("button", { ref: btnRef, onClick: onClick, class: "btn btn-link u-px2", type: "button", "data-field-id": dataFieldId }, label)),
        trigger === "block" && (h("i", { class: "icon icon-angle-right icon-2x icon-btn", "aria-hidden": "true" }))));
});
const Container = observer((props) => {
    const { btnRef, actionTrigger, children, actionLabel, dataFieldId, onClick, } = props;
    switch (actionTrigger) {
        case "button":
            return (h("article", { class: `m-edit-block ${props.hasError ? "has-error" : ""}`, "aria-label": props.ariaLabel }, children));
        case "block":
            return (h("button", { ref: btnRef, "data-field-id": dataFieldId, onClick: onClick, disabled: props.isDisabled, class: `m-edit-block m-edit-block--button ${props.hasError ? "has-error" : ""}`, "aria-label": `${props.ariaLabel}: ${props.ariaValue}, ${actionLabel}`, type: "button" }, children));
    }
});
export default observer(EditBlock);
